






















































import { Component, Inject, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import {
  IBasketProviderMethods,
  IBasketProviderData
} from "@/models/providers/baskets";

@Component
export default class Promotions extends Mixins(HasValidation) {
  // Inject
  @Inject({ from: "providerData" })
  public readonly $basketData!: () => IBasketProviderData;
  @Inject({ from: "providerMethods" })
  public readonly $basketMethods!: IBasketProviderMethods;
  // Data
  public isProcessing: Record<string, boolean> = {};
  public code = "";

  public get basketData() {
    return this.$basketData();
  }
  public get basketPromotions() {
    return this.$_.filter(
      this.$_.get(this.basketData, "basket.promotions", []),
      basketPromotion => !basketPromotion.promotion.adjusted_basket_id
    );
  }

  public get isAdjustedBasket() {
    return this.$_.some(
      this.$_.get(this.basketData, "basket.promotions", []),
      basketPromotion => !!basketPromotion.promotion.adjusted_basket_id
    );
  }

  public async removeCoupon(id) {
    if (this.isProcessing[id]) return;
    this.$set(this.isProcessing, id, true);
    try {
      await this.$basketMethods.deletePromotion(id);
      await this.$basketMethods.refreshBasketData(true);
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.$delete(this.isProcessing, id);
    }
  }

  public async addPromotion() {
    if (!this.code.length || this.isProcessing["apply"]) return;
    this.$set(this.isProcessing, "apply", true);
    this.removeError("code");
    try {
      await this.$basketMethods.addPromotion(this.code);
      await this.$basketMethods.refreshBasketData();
      this.code = "";
    } catch (error) {
      if (
        this.$store.getters["api/is403"](error) ||
        this.$store.getters["api/is401"](error)
      ) {
        this.$basketMethods.forceBasketReset();
      }
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
      if (!this.hasError("code")) {
        this.validationErrors["code"].push(
          this.$_.get(error, "response.data.error.message", "")
        );
      }
    } finally {
      this.$delete(this.isProcessing, "apply");
    }
  }

  public async clearAdjustedTotal() {
    if (this.isProcessing.clear) return;
    try {
      this.$basketMethods.setIsProcessing(true);
      this.$set(this.isProcessing, "clear", true);

      const autoPromotionId = this.$_.get(
        this.$_.find(
          this.$_.get(this.basketData, "basket.promotions", []),
          basketPromotion => !!basketPromotion.promotion.adjusted_basket_id
        ),
        "id"
      );

      await this.$basketMethods.deletePromotion(autoPromotionId);
      await this.$basketMethods.refreshBasketData(true);
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.$basketMethods.setIsProcessing(false);
      this.$delete(this.isProcessing, "clear");
    }
  }
}
